import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import './Footer.scss';

const Footer = props => {
  const { langKey, data } = props;
  const content = langKey === 'fr' ? data.fr : data.en;

  content.slugPage.unshift(''); //* add 'home' page link to the array

  return (
    <div className="footer">
      <div className={props.className || 'container-fluid'}>
        <div className="row">
          {/* nos marques */}
          <div className="col-md-4">
            <Info title={content.titreColonne1}>
              {content.listColonne1.map((brand, i) => {
                return (
                  <FooterLink
                    key={i}
                    href={content.urlColonne1[i]}
                    noOpener={true}
                  >
                    {brand}
                  </FooterLink>
                );
              })}
            </Info>
          </div>
          {/* plan du site */}
          <div className="col-md-4">
            <Info title={content.titreColonne2}>
              {content.listColonne2.map((page, i) => {
                return (
                  <FooterLink key={i} to={`/${langKey}/${content.slugPage[i]}`}>
                    {page}
                  </FooterLink>
                );
              })}
            </Info>
          </div>
          {/* contact */}
          <div className="col-md-4">
            <Info title={content.titreColonne3}>
              <li>
                <i className="material-icons">location_on</i> OFFSHORE SERVICES
              </li>
              <li className="no-icon">Port de Cap d'Ail</li>
              <li className="no-icon">06320 CAP D'AIL - FRANCE</li>
              <li>
                <i className="material-icons">phone</i>{' '}
                <a href="tel:+33493783534">+33 (0)4.93.78.35.34</a>
              </li>
              <li>
                <i className="material-icons">mail</i>{' '}
                <a href="mailto:mail@offshoreservices.fr">
                  mail@offshoreservices.fr
                </a>
              </li>
            </Info>
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  langKey: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.object,
};

const Info = props => (
  <div className="footer-info">
    <div className="footer-title">
      <h3>{props.title}</h3>
      <hr className="footer-divider" />
    </div>
    <div className="footer-body">
      <ul>{props.children}</ul>
    </div>
  </div>
);

Info.propTypes = {
  title: PropTypes.string,
  children: PropTypes.array,
};

const FooterLink = props => (
  <li>
    {props.href ? (
      <a
        href={props.href}
        target="_blank"
        rel={props.noOpener ? 'noopener' : ''}
      >
        {props.children}
      </a>
    ) : (
      <Link to={props.to}>{props.children}</Link>
    )}
  </li>
);

FooterLink.propTypes = {
  href: PropTypes.string,
  noOpener: PropTypes.bool,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js